import API from "../API";
import { AxiosResponse } from "axios";

export const listPlan = (): Promise<AxiosResponse> =>
  API.get("/group/billing/plans/list");
